module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"listOfProperties":"Liste des propriétés"}}')
  delete Component.options._Ctor
}
